import type { ComponentProps } from "react";

import { cn } from "@/lib/helpers/cn";
import { Heading2 } from "@/ui2/atoms/Heading";

export function ViewTitle({ className, ...props }: ComponentProps<typeof Heading2>) {
  return (
    <Heading2
      as="h1"
      className={cn("trim-both tw:mt-2! tw:text-[#668391]", className)}
      size={4}
      {...props}
    />
  );
}
